export class ServiceRouter {
  public static getAuthenticateUrl = (): string => {
    return `${ServiceRouter.getServiceUrl()}auth/login`;
  };

  public static getLogoutUrl = (): string => {
    return `${ServiceRouter.getServiceUrl()}authwithsession/logout`;
  };

  public static getServiceUrl = (): string => {
    // TODO
    // return 'https://localhost:7113/api/';
    // NOT: eski IIS'teki '/services' sanal dizini K8s'te yok; o yol Backoffice UI'ina
    // (Next.js) dusup CORS basliksiz 404 donuyordu (31.08). API dogrudan /api altinda.
    return 'https://backoffice.stoneity.com/api/';
  };
}
